"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = Object.freeze({
  VIDYARD_TOS_STATUS: 1,
  DISMISS_VIDEO_PQL_V1: 4,
  IMPORT_IMAGE_COPYRIGHT_NOTICE: 5,
  PICKER_CANVA_POPUP: 6,
  SHUTTERSTOCK_TOS: 7,
  SHUTTERSTOCK_FOLDER_ID: 8
});

exports.default = _default;
module.exports = exports.default;